module.exports = __webpack_public_path__ + "static/media/arrow-right.1cb2bbd6.svg";